import { Avatar, Box, Flex } from '@chakra-ui/react'

type ResolverDisplayProps = {
  state: string
  resolvedById?: string
  resolvedByName?: string
}

export const ResolverDisplay = ({ state, resolvedById, resolvedByName }: ResolverDisplayProps) => {
  const resolver = state === 'RESOLVED' && !resolvedById ? 'Systém' : resolvedByName

  return resolver ? (
    <Flex align="center" gap={2}>
      <Avatar size="sm" colorScheme="neutral" name={resolver} />
      <Box>{resolver}</Box>
    </Flex>
  ) : null
}
